<template>
  <v-row>
    <v-col>
      <section v-if="!flow">
        <h2>Choose a Product</h2>
        <v-row>
          <v-col class="col-6 col-md-6 col-12">
            <v-card>
              <v-img
                src="../assets/images/shop-custom-seat-covers.jpg"
              />
              <v-card-title>
                <h3>Custom Seat Covers</h3>
                <p>Design custom seat covers for your vehicle.</p>
              </v-card-title>
              <v-card-actions>
                <v-btn color="primary" @click="flow='covers'" class="next">Shop Now</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col class="col-6 col-md-6 col-12">
            <v-card>
              <v-img
                src="../assets/images/shop-accessories.jpg"
              />
              <v-card-title>
                <h3>Other Products</h3>
                <p>More from Ruff Tuff, including our tactical seat-back storage system, the Flex OPS<sup>&trade;</sup> Package.</p>
              </v-card-title>
              <v-card-actions>
                <v-btn color="primary" @click="flow='accessories'" class="next">Shop Now</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </section>

      <section v-if="flow === 'covers'">
        <h2>Let's Get Started</h2>
        <p>We make your custom seat covers to order. For your seat covers to fit your seats, it's crucial that you answer all questions accurately. If you're unsure of any answer, please don't guess. If you're uncertain how to answer a question, please call us at 801-972-5845 or email us at customerservice@rufftuff.com. We will be happy to help you.</p>
        <v-expansion-panels
          accordion
          focusable
          mandatory
          readonly
          id="starting"
          v-model="panel"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>Tell us about your vehicle and seats</v-expansion-panel-header>
            <v-expansion-panel-content>
              <Vehicle onlyAcc/>
              <Attributes />
              <Variations />
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Choose your custom seat covers</v-expansion-panel-header>
            <Seats />
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Choose your options</v-expansion-panel-header>
            <Options />
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Choose other products</v-expansion-panel-header>
            <Accessories onlyAcc />
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Review and Checkout</v-expansion-panel-header>
            <Checkout />
          </v-expansion-panel>
        </v-expansion-panels>
      </section>

      <section v-if="onlyAcc">
        <h2>Let's Get Started</h2>
        <p>We make your custom seat covers to order. For your seat covers to fit your seats, it's crucial that you answer all questions accurately. If you're unsure of any answer, please don't guess. If you're uncertain how to answer a question, please call us at 801-972-5845 or email us at customerservice@rufftuff.com. We will be happy to help you.</p>
        <p>If you don't see your vehicle's make, model, or year, or if no seat descriptions match your seats, please call us at 801-972-5845 or email us at customerservice@rufftuff.com.</p>
        <v-expansion-panels
          accordion
          focusable
          mandatory
          readonly
          id="starting"
          v-model="panel"
        >
          <v-expansion-panel>
            <v-expansion-panel-header>Choose other products</v-expansion-panel-header>
            <Accessories />
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>Review and Checkout</v-expansion-panel-header>
            <Checkout onlyAcc />
          </v-expansion-panel>
        </v-expansion-panels>
      </section>

    </v-col>
  </v-row>
</template>

<style scoped lang="scss">
.v-expansion-panel-header {
  min-height: 0;

  @media screen and (min-width: 600px) {
    min-height: 64px;
  }
}
.v-expansion-panel-header,
.v-expansion-panel-header--active,
.v-expansion-panel-header--mousedown {
  background-color: #f2f2f2;
  color: $brand-primary;
  font-family: $heading-font-family;
  font-size: 20px;
  font-weight: 200;
  &::before {
    background-color: #b2b2b2;
  }

  @media screen and (min-width: 600px) {
    font-size: 30px;
  }
}
.v-expansion-panel-header--active,
.v-expansion-panel-header--mousedown {
  background-color: #b2b2b2
}

h3 {
  font-size: 1.3rem;
  width: 100%;
  padding-bottom: 16px;
}

p {
  font-size: 0.938rem;
  line-height: 1.5;
  word-break: break-word;
  padding-left: 0;
  padding-right: 0;
}

.v-card {
  min-height: 440px;
}

.v-card__title {
  min-height: 150px;
  flex-direction: column;
  align-items: flex-start;
}

.v-card__actions {
  padding: 16px;
}

.v-btn {
  font-size: 18px;
  padding: 10px 25px !important;
  height: auto !important;
  width: 100%;
  margin-bottom: 20px;

  @media screen and (min-width: 600px) {
    width: auto;
  }
}
</style>

<script>
import { mapState } from 'vuex'
import Vehicle from './Vehicle'
import Attributes from './Attributes'
import Variations from './Variations'
import Seats from './Seats'
import Options from './Options'
import OptionPrices from '@/services/options'
import Checkout from './Checkout'
import Accessories from './Accessories.vue'

export default {
  name: 'Main',
  components: {
    Vehicle,
    Attributes,
    Variations,
    Seats,
    Options,
    Checkout,
    Accessories
  },
  data () {
    return {
      flow: null
    }
  },
  computed: {
    ...mapState([
      'panel',
    ]),
    onlyAcc() {
      return this.flow === 'accessories'
    }
  },
  methods: {
    async getOptionPrices() {
      const prices = await OptionPrices.get()
      this.$store.commit('setOptionPrices', prices)
    }
  },
  mounted () {
    const src = this.$route.query.src
    if (src) {
      this.$store.commit('setSrc', src) 
    }

    this.getOptionPrices()
  }
}
</script>
